import { render } from "./TreatmentsModal.vue?vue&type=template&id=00073886&ts=true"
import script from "./TreatmentsModal.vue?vue&type=script&lang=ts"
export * from "./TreatmentsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__